<div class="modal-header">
  <h5 class="modal-title">
    <span *ngIf="!isPost && !isCat" class="mx-1">გვერდის</span> 
    <span *ngIf="isPost" class="mx-1">სტატიის</span> 
    <span *ngIf="isCat" class="mx-1">
      <span *ngIf="menuid == 72">კატეგორიის</span>
      <span *ngIf="menuid == 73">მუნიციპალიტეტის</span>
    </span> 
    <span *ngIf="!this.editingPageId">დამატება</span> <span *ngIf="this.editingPageId">რედაქტირება</span></h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal.emit()"></button>
</div>
<div class="modal-body">

  <form [formGroup]="pageForm">

    <div class="form-floating mb-3" *ngIf="!isPost && !isCat">
      <select formControlName="source" class="form-select" id="source">
        <option value="pages">სტანდარტული გვერდი</option>
        <option value="catalogs"> სტატიის გვერდი (კატალოგი)</option>
        <option value="page-post"> სტატიის გვერდი (სტანდარტული)</option>
      </select>
      <label for="source">გვერდის ტიპი</label>
      <div class="invalid-feedback">error</div>
    </div>

    <div class="form-floating mb-3">
      <input
        type="text"
        class="form-control"
        formControlName="title"
        id="title"
        placeholder="სათაური"
        required>
      <label for="title">სათაური</label>
      <div class="invalid-feedback">
        error
      </div>
    </div>

    <div class="form-check form-switch mb-3" *ngIf="!isCat">
      <input type="checkbox" class="form-check-input" id="visibility" formControlName="visibility">
      <label class="form-check-label" for="visibility">
        <span *ngIf="!isPost" class="mx-1">გვერდის</span> 
        <span *ngIf="isPost" class="mx-1">სტატიის</span>  
        გამოჩენა</label>
    </div>

    <div *ngIf="!isPost && !isCat">

      <div *ngIf="pageForm.get('visibility')?.value">
        <div class="form-floating mb-3">
        <input
          type="text"
          class="form-control"
          formControlName="menutitle"
          id="menutitle"
          placeholder="მენიუს სათაური"
          required>
        <label for="menutitle">მენიუს სათაური</label>
        <div class="invalid-feedback">
          error
        </div>
      </div>

      <div class="form-floating mb-3">
        <select class="form-select" formControlName="menuid" id="menuid">
          <option [value]="0">არ ჩანდეს მენიუში</option>
          <option [value]="1">ზედა მენიუ</option>
          <option [value]="4">ქვედა მენიუ</option>
        </select>
        <label for="menuid">აირჩიეთ მენიუს ზოლი</label>
      </div>

      <div class="mb-3">
          <app-parent-page-select
            [menuId]="pageForm.get('menuid')?.value"
            [selectedPageId]="pageForm.get('masterid')?.value"
            (selected)="pageForm.get('masterid')?.setValue($event)">
          </app-parent-page-select>
        </div>
      </div>

    
      <div class="form-check form-switch mb-3" *ngIf="pageForm.get('source')?.value !== 'catalogs' && pageForm.get('tmp')?.value !== 'items'">
        <input type="checkbox" class="form-check-input" id="showinredirectlink" formControlName="showinredirectlink">
        <label class="form-check-label" for="showinredirectlink">გვერდის გადამისამართება</label>
      </div>

   

      <div *ngIf="pageForm.get('showinredirectlink')?.value">
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-redirectlink">https:</span>
          <div class="form-floating">
            <input
              type="text"
              class="form-control"
              formControlName="redirectlink"
              id="redirectlink"
              placeholder="მენიუს სათაური"
              required>
            <label for="redirectlink">ბმული</label>
            <div class="invalid-feedback">
              error
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!pageForm.get('showinredirectlink')?.value">

      <div class="form-floating mb-3" *ngIf="!isCat">
        <input
          type="datetime-local"
          class="form-control"
          formControlName="postdate"
          id="postdate"
          placeholder="თარიღი"
          required>
        <label for="postdate">თარიღი</label>
        <div class="invalid-feedback">
          error
        </div>
      </div>

      <div *ngIf="pageForm.get('source')?.value !== 'catalogs' && pageForm.get('tmp')?.value !== 'items'" class="mb-3">

        <editor
          *ngIf="!isCat"
          [init]="{
            base_url: '/tinymce',
            license_key: 'gpl',
            suffix: '.min',
            plugins: 'link image fullscreen',
            toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | bullist numlist | link image | fullscreen',
            file_picker_callback: openFileManagerWrapper,
        
          }"
          formControlName="content"
        ></editor>

        <div class="mt-3 mb-3">
          
          <div class="d-flex align-items-start flex-column gap-3">

            <img
              *ngIf="pageForm.get('image1')?.value"
              [src]="getFullImageUrl(pageForm.get('image1')?.value)"
              alt="არჩეული სურათი"
              class="img"
            />

          <button type="button" class="btn btn-primary" (click)="openFileManagerForImage1()"[disabled]="loadSave">
              <i class="fi fi-rr-picture"></i> 
              <span *ngIf="pageForm.get('image1')?.value"> სურათის შეცვლა</span>
              <span *ngIf="!pageForm.get('image1')?.value"> სურათის არჩევა</span>
            </button>
            
          </div>
        </div>

        <div class="input-group mb-3" *ngIf="!isCat">
          <span class="input-group-text" id="youtube"><i class="fi fi-brands-youtube"></i> </span>
          <div class="form-floating">
            <input type="text" formControlName="youtube" id="youtube" class="form-control" placeholder="Youtube ბმული" required />
            <label for="youtube">Youtube ბმული</label>
          </div>
        </div>

      </div>
      
      
      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-slug">ajaraheritage.ge/page/</span>
        <div class="form-floating">
          <input
            type="text"
            class="form-control"
            formControlName="slug"
            id="slug"
            placeholder="მენიუს სათაური"
            required
            [class.is-invalid]="pageForm.get('slug')?.invalid && pageForm.get('slug')?.touched"
            [class.is-valid]="pageForm.get('slug')?.valid && !pageForm.get('slug')?.hasError('slugTaken')">
          <label for="slug">ბმული</label>
          <div class="invalid-feedback" *ngIf="pageForm.get('slug')?.hasError('slugTaken')">
            ეს ბმული უკვე გამოიყენება
          </div>
        </div>
      </div>
   
      <div *ngIf="pageForm.get('source')?.value !== 'catalogs' && pageForm.get('tmp')?.value !== 'items' && !isCat" class="mb-3">
          
          <app-gallery-selector
            [multiselect]="true"
            (selected)="onGalleryImagesSelected($event)">
          </app-gallery-selector>

          <div *ngIf="pageForm.get('gallery')?.value?.length" class="mt-3">
            <label class="form-label mb-2">არჩეული გალერიის სურათები</label>
              <div
                cdkDropList
                [cdkDropListData]="pageForm.get('gallery')?.value"
                (cdkDropListDropped)="dropGalleryImage($event)"
                class="d-flex flex-wrap gap-3"
                  cdkDropListSortingDisabled="false"
              >
              <div
                class="gallery-image-preview position-relative"
                *ngFor="let img of pageForm.get('gallery')?.value; let i = index"
                cdkDrag
              >
                <img [src]="getFullImageUrl(img)" class="img-thumbnail" width="150" />
                <span
                  class="delete position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                  (click)="removeGalleryImage(i)">
                  <i class="fi fi-rr-trash"></i>
                </span>
              </div>
            </div>
          </div>
      </div>
     
      <button type="button" class="btn btn-outline-secondary" *ngIf="!isCat" (click)="openMetaFormModal()">
            მეტა მონაცემები
      </button>
    </div>
  </form>
</div>
<div class="modal-footer d-flex justify-content-between">
  <div>
    <span *ngIf="pageForm.get('author')?.value"><b>ავტორი: </b>{{pageForm.get('author')?.value}}</span>
  </div>
  <div>
    <button type="button" class="btn btn-secondary mx-1" (click)="closeModal.emit()">დახურვა</button>
    <button type="button" class="btn btn-primary" (click)="savePage()" [disabled]="loadSave">
      <span *ngIf="loadSave" class="spinner-border spinner-border-sm" role="status" ></span> 
      <span *ngIf="!this.editingPageId">დამატება</span>
      <span *ngIf="this.editingPageId">შენახვა</span>
    </button>
  </div>
</div>

<ng-template #fileManagerModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">ფაილის არჩევა</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <app-file-manager
      [type]="'image'"
      (fileSelected)="onFileSelectedFromManager($event, modal)">
    </app-file-manager>
  </div>
</ng-template>


<ng-template #metaFormModal let-modal>
  <app-meta-form-modal
    [meta_desc]="pageForm.get('meta_desc')?.value"
    [meta_keys]="pageForm.get('meta_keys')?.value"
    (save)="pageForm.patchValue($event); modal.close()"
  ></app-meta-form-modal>
</ng-template>